import { LIST_STYLES as e } from "../../constants/default-styles.mjs";
import { convertStyleObjectToCss as t } from "../../utils/style-helpers.mjs";
import { getBulletListStyleType as n, getOrderedListStyleType as r } from "./utils/list.mjs";
import { CustomBulletList as i } from "./custom-bullet-list.mjs";
import { CustomOrderedList as a } from "./custom-ordered-list.mjs";
import { NodeViewContent as o, NodeViewWrapper as s, ReactNodeViewRenderer as c, mergeAttributes as l } from "@tiptap/react";
import { jsx as u } from "react/jsx-runtime";
import { Plugin as d, PluginKey as f } from "@tiptap/pm/state";
import { BulletList as p, ListItem as m, OrderedList as h } from "@tiptap/extension-list";
//#region src/extensions/list-extension/list-extension.tsx
var g = new f("listItemStyle"), _ = ({ node: e }) => {
	let t = {};
	return e.attrs.fontSize && (t.fontSize = e.attrs.fontSize), e.attrs.fontFamily && (t.fontFamily = e.attrs.fontFamily), e.attrs.color && (t.color = e.attrs.color), e.attrs.textAlign && (t.textAlign = e.attrs.textAlign), /* @__PURE__ */ u(s, {
		as: "li",
		style: t,
		children: /* @__PURE__ */ u(o, {})
	});
}, v = m.extend({
	content: "block*",
	addAttributes() {
		return {
			...this.parent?.(),
			fontSize: {
				default: null,
				parseHTML: () => null,
				renderHTML: () => ({})
			},
			fontFamily: {
				default: null,
				parseHTML: () => null,
				renderHTML: () => ({})
			},
			color: {
				default: null,
				parseHTML: () => null,
				renderHTML: () => ({})
			}
		};
	},
	addNodeView() {
		return c(_);
	},
	addProseMirrorPlugins() {
		return [new d({
			key: g,
			appendTransaction: (e, t, n) => {
				if (!e.some((e) => e.docChanged)) return null;
				let r = n.tr, i = !1, a = (e) => e?.find((e) => e.type.name === "textStyle"), o = (e) => {
					let t = e.firstChild;
					if (!t) return null;
					if (t.isText) return a(t.marks);
					let n = t.firstChild;
					return n?.isText ? a(n.marks) : null;
				};
				return n.doc.descendants((e, t) => {
					if (e.type.name === "listItem") {
						let s = null, c = null, l = null, u = o(e), d = n.selection, f = d.anchor >= t && d.anchor < t + e.nodeSize || d.head >= t && d.head < t + e.nodeSize ? a(n.storedMarks) : null, p = u || f;
						p && (s = p.attrs.fontSize, c = p.attrs.fontFamily, l = p.attrs.color), (e.attrs.fontSize !== s || e.attrs.fontFamily !== c || e.attrs.color !== l) && (r.setNodeMarkup(t, void 0, {
							...e.attrs,
							fontSize: s,
							fontFamily: c,
							color: l
						}), i = !0);
					}
				}), i ? r : null;
			}
		})];
	},
	renderHTML({ HTMLAttributes: e, node: n }) {
		let r = {};
		return n.attrs.fontSize && (r.fontSize = n.attrs.fontSize), n.attrs.fontFamily && (r.fontFamily = n.attrs.fontFamily), n.attrs.color && (r.color = n.attrs.color), n.attrs.textAlign && (r.textAlign = n.attrs.textAlign), [
			"li",
			l(e, { ...Object.keys(r).length > 0 ? { style: t(r) } : {} }),
			0
		];
	}
}), y = p.extend({
	addAttributes() {
		return { depth: { default: 0 } };
	},
	addNodeView() {
		return c(i);
	},
	renderHTML({ HTMLAttributes: r }) {
		let { depth: i } = r;
		return [
			"ul",
			l(r, { style: t({
				...e,
				listStyleType: n(i)
			}) }),
			0
		];
	}
}), b = h.extend({
	addAttributes() {
		return { depth: { default: 0 } };
	},
	addNodeView() {
		return c(a);
	},
	renderHTML({ HTMLAttributes: n }) {
		let { depth: i } = n;
		return [
			"ol",
			l(n, { style: t({
				...e,
				listStyleType: r(i)
			}) }),
			0
		];
	}
});
//#endregion
export { y as BulletListExtension, v as ListItemExtension, b as OrderedListExtension };
